import { render, staticRenderFns } from "./UploadTable.vue?vue&type=template&id=3284e322&scoped=true&"
import script from "./UploadTable.vue?vue&type=script&lang=js&"
export * from "./UploadTable.vue?vue&type=script&lang=js&"
import style0 from "./UploadTable.vue?vue&type=style&index=0&id=3284e322&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3284e322",
  null
  
)

export default component.exports